import * as React from "react";
import { forwardRef } from "react";
const SvgIconCategorization = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.5 0L4 9H15L9.5 0ZM9.5 3.84L11.43 7H7.56L9.5 3.84ZM15 11C12.51 11 10.5 13.01 10.5 15.5C10.5 17.99 12.51 20 15 20C17.49 20 19.5 17.99 19.5 15.5C19.5 13.01 17.49 11 15 11ZM0.5 19.5H8.5V11.5H0.5V19.5ZM2.5 13.5H6.5V17.5H2.5V13.5Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIconCategorization);
export { ForwardRef as ReactComponent };
